export default __webpack_public_path__ + "static/media/d_i_statistic_icon.32bd078d.svg";